import React, { useState, useEffect, useCallback } from 'react';
import CustomProgressBar from '../CustomProgressBar';
import { Tooltip } from 'components/Common/Tooltip/Tooltip';
import Icon from 'components/Icons/Icon';
import { useWindowSize } from 'components/Common/CustomHooks/useWindowSize';

const ProgressSection = ({ title, total, processed, percentageVal, usePercentage, active, hide, enableQueueWrapper, queue }) => {

  const [percentage, setPercentage] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(true);
  const [queueChangeDetected, setQueueChangeDetected] = useState(false);
  
  const windowSize = useWindowSize({
    customBreakpoints: {
      md: 700,
    }
  });

  useEffect(() => {
    setQueueChangeDetected(prev => prev + 1);
  }, [queue]);

  const calculatePercentage = () => {
    if (total && processed) {
      return Math.ceil(processed / total * 100)
    }
  }
  
  useEffect(() => {
    if (usePercentage) { 
      setPercentage(percentageVal);
      return;
    } else if (total && processed) {
      const conversion = calculatePercentage(total, processed);
      setPercentage(conversion);
    }
  }, [total, processed, usePercentage, percentageVal])

  useEffect(() => {
    setShowProgressBar(() => {
      if (!active) { return false };
      if (usePercentage && percentageVal) { return true };
      if (total !== processed && processed < total) { return true };

      return false;
    });
  }, [total, processed, usePercentage, percentageVal, active])

  const dynamicDescription = useCallback(() => {
    return enableQueueWrapper && queue.length > 0 ?
      `${queue.length} ${title.toLowerCase()}${queue.length > 1 ? "s" : ""} waiting` 
    :
      windowSize?.width < 1100 && !active ?
        `No ${title.toLowerCase()} in progress`
      :
        ""
  }, [queue, title, active, enableQueueWrapper, windowSize]);

  const description = dynamicDescription();

  const renderContent = () => (
    <div className='progress-content'>
      <div className={`d-flex align-items-center w-100 progress-section px-0 py-0 ${hide ? 'hide' : 'show'}-section`}>
        <span className='pr-2 py-0 my-0'>{title}:</span>
        {showProgressBar ?
          <CustomProgressBar show={showProgressBar} value={percentage ?? 0} styling='mt-1 custom-width' tooltip={true} />
        :
          <span className='progress-text'>
            {
              windowSize?.width >= 1100 ?
                `No ${title.toLowerCase()} in progress` 
              : 
                "--"
            }
          </span>
        }
      </div>
    </div>
  )
  
  return (
    <>
      {enableQueueWrapper && queue.length > 0 && description ?
        <div className={`queue-wrapper ${hide ? 'hide' : 'show'}-section`}>
          <Tooltip
            placement='top'
            description={dynamicDescription()}
          >
            <span className='queue-icon'>
              <span className={`text ${queueChangeDetected ? 'animate-queue-change' : ''}`}>{queue.length}</span>
            </span>
          </Tooltip>
          {renderContent()}
        </div>
      :
        windowSize?.width < 1100 && description ?
          <Tooltip
            placement='top'
            description={dynamicDescription()}
          >
            {renderContent()}
          </Tooltip>
        :
          renderContent()
        }
    </>
  )
}

export default ProgressSection;